<template>
    <span
        :class="[
            'switch-lang',
            'is-' + color,
            isOpen && 'is-open',
            !isOpen && 'is-close'
        ]"
    >
        <button class="current" @click.prevent.stop="isOpen = !isOpen">
            <IconPlanet :color="color"/> {{ currentLang }} <span class="helper">▾</span>
        </button>
        <span
            class="hover"
            :style="{ height: (langList.length - 1) + '00%' }"
        >
            <template v-for="lang in otherLangs">
                <component
                    :is="lang !== currentLang ? 'router-link' : 'span'"
                    :to="$trl(getCurrentPage(lang))"
                    :key="lang"
                    :class="['hover-item', lang === currentLang && 'is-active']"
                >
                    {{ lang }}
                </component>
            </template>
        </span>
    </span>
</template>
<script>
import IconPlanet from '@/components/IconPlanet'
export default {
    components: {
        IconPlanet
    },
    props: {
        currentLang: {
            type: String,
            default: 'fr'
        },
        color: {
            type: String,
            default: 'grey',
            validator: function (direction) {
                return ['grey', 'white', 'red'].indexOf(direction) > -1
            }
        },
        classNames: {
            type: Object,
            default: function () { return { } },
            validator: function (classNames) {
                let valid = true
                Object.keys(classNames).forEach(elementName => {
                    valid = valid && ['hoverItem'].indexOf(elementName) > -1
                })
                return valid
            }
        }
    },
    data() {
        return {
            langList: ['en', 'fr', 'es'],
            isOpen: false
        }
    },
    computed: {
        otherLangs() {
            return this.langList.filter(_ => _ !== this.currentLang)
        }
    },
    watch: {
        isOpen(isOpen) {
            if(isOpen) {
                document.body.addEventListener('click', this.close)
            }
        }
    },
    methods: {
        close() {
            this.isOpen = false
            document.body.removeEventListener('click', this.close)
        },
        getCurrentPage(lang) {
            const route = {
                name: this.$route.name,
                params: JSON.parse(JSON.stringify(this.$route.params))
            }
            route.params.locale = lang
            return route
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.switch-lang
    position: relative
    display: flex
    align-items: center
    &.is-white
        color: #FFF
    &.is-grey
        color: #636772
    &.is-red
        color: #ff2b2a
.current
    display: flex
    align-items: center
    cursor: pointer
    height: 100%
    padding-left: 1em
    padding-right: 1em
    @include media-breakpoint-down($lg)
        font-size: 12px
        font-weight: 500
        text-transform: capitalize
.icon-planet
    margin-right: .3em
.hover
    position: absolute
    top: 100%
    left: 0
    width: 100%
    display: flex
    flex-direction: column
.hover-item
    background-color: #ffffff
    width: 100%
    flex: 1
    display: flex
    align-items: center
    justify-content: center
    .is-white &
        background-color: transparent
    &.is-active
        opacity: 0.5
.switch-lang
    // &.is-open
    //     .current
            // opacity: 0
    &.is-close
        .hover
            pointer-events: none
            opacity: 0
.helper
    display: inline-block
    margin-left: .3em
    .is-open &
        transform: rotate(180deg)
</style>
